import { Label, NativeSelect, NativeSelectOption } from 'shared-ui';

import { EXPORT_FORMAT_OPTIONS, type ExportFormat } from '@/utils/exportWorkbook';

interface DownloadFormatFieldProps {
    id: string;
    value: ExportFormat;
    onChange: (value: ExportFormat) => void;
}

/** Shared "Format" field for the download panels (label + Excel/CSV select). */
export function DownloadFormatField({ id, value, onChange }: DownloadFormatFieldProps) {
    return (
        <div className="space-y-1.5">
            <Label htmlFor={id} className="text-foreground text-sm leading-5 font-medium">
                Format
            </Label>
            <NativeSelect
                id={id}
                value={value}
                onChange={(e) => {
                    onChange(e.target.value as ExportFormat);
                }}
                className="panel-select text-muted-foreground w-full text-sm leading-5 font-normal tracking-normal"
            >
                {EXPORT_FORMAT_OPTIONS.map((o) => (
                    <NativeSelectOption key={o.value} value={o.value}>
                        {o.label}
                    </NativeSelectOption>
                ))}
            </NativeSelect>
        </div>
    );
}
